import { Pipe, PipeTransform } from "@angular/core";
import { Status } from "../status-classes";

@Pipe({ name: "alertMetric" })
export class AlertMetricPipe implements PipeTransform {
  public transform(alert: any) {
    const statusClass = Status.CLASSES[alert.params.statusClass] || "";
    return `${statusClass} ${alert.params.metric}`.trim();
  }
}
